import RainbowLink from '@otovo/shared/components/RainbowLink/RainbowLink';
import { cn } from '@otovo/shared/lib/classNames';

type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  className?: string;
};

const baseClasses =
  'inline-block rounded-md bg-peach-60 px-6 py-3 text-center text-white hover:bg-peach-70 !no-underline';

const CTAButton = ({
  children,
  href,
  className,
  onClick,
  type = 'button',
}: CTAButtonProps) => {
  if (!href) {
    return (
      <button
        type={type}
        onClick={onClick}
        className={cn(baseClasses, className)}
      >
        {children}
      </button>
    );
  }
  return (
    <RainbowLink href={href} className={cn(baseClasses, className)}>
      {children}
    </RainbowLink>
  );
};

export default CTAButton;
